export default "__VITE_ASSET__DunKxBUc__"